import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useMessageStore } from '../../../store/message';
import Alert from './Alert';
import Confirm from './Confirm';
import Prompt from './Prompt';
import Toast from './Toast';

function MessageCenter() {
  const { messages, removeMessage } = useMessageStore();

  useEffect(() => {
    messages.forEach((message) => {
      if (message.timeout) {
        const timer = setTimeout(() => {
          removeMessage(message.id);
        }, message.timeout);

        return () => clearTimeout(timer);
      }
    });
  }, [messages, removeMessage]);

  return createPortal(
    <div className="fixed inset-0 z-[100] pointer-events-none">
      {/* Toasts - Top Center */}
      <div className="absolute top-4 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 w-full max-w-sm px-4">
        {messages
          .filter((m) => m.type === 'toast')
          .map((message) => (
            <Toast key={message.id} message={message} onClose={() => removeMessage(message.id)} />
          ))}
      </div>

      {/* Modal Background - Only show when there are modals */}
      {messages.some(m => m.type !== 'toast') && (
        <div className="fixed inset-0 bg-black bg-opacity-50 pointer-events-auto" />
      )}

      {/* Alerts - Center */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        {messages
          .filter((m) => m.type === 'alert')
          .map((message) => (
            <div key={message.id} className="pointer-events-auto">
              <Alert message={message} onClose={() => removeMessage(message.id)} />
            </div>
          ))}
      </div>

      {/* Confirms - Center */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        {messages
          .filter((m) => m.type === 'confirm')
          .map((message) => (
            <div key={message.id} className="pointer-events-auto">
              <Confirm message={message} onClose={() => removeMessage(message.id)} />
            </div>
          ))}
      </div>

      {/* Prompts - Center */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        {messages
          .filter((m) => m.type === 'prompt')
          .map((message) => (
            <div key={message.id} className="pointer-events-auto">
              <Prompt message={message} onClose={() => removeMessage(message.id)} />
            </div>
          ))}
      </div>
    </div>,
    document.body
  );
}

export default MessageCenter